// extracted by css-extract-rspack-plugin
export default {"percent":"dWWrXs","integer":"c4THHr"};